/* tslint:disable */
/* eslint-disable */
/**
 * B2X Roles & Permissions API spec
 * B2X Contract API specs for middleware (BE) and frontend components (FE). We agreed to cover create / update / delete usecases with generic service operations which are also capable to serve multiple future clients (e.g. browser & mobile) at the same time.
 *
 * The version of the OpenAPI document: 1.121.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * Enumerated type of Account verification state that indicates if the company account is verified
 * @export
 * @enum {string}
 */
export const AccountVerificationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a binary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const BinaryBooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR'
};
/**
 * Describes a binary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const BinaryFilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER'
};
/**
 * Describes a binary boolean operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const BooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR',
    Not: 'NOT'
};
/**
 * Enumerated type of business type for which is the company used for
 * @export
 * @enum {string}
 */
export const BusinessType = {
    Other: 'LOB_OTHER',
    Construction: 'LOB_CONSTRUCTION',
    Emergency: 'LOB_EMERGENCY',
    Logistic: 'LOB_LOGISTIC',
    Manufacturing: 'LOB_MANUFACTURING',
    PeopleMover: 'LOB_PEOPLE_MOVER',
    Rental: 'LOB_RENTAL',
    ServiceWorkshop: 'LOB_SERVICE_WORKSHOP',
    TradeEgrocery: 'LOB_TRADE_EGROCERY'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CardOnFileAuthenticationStatusType = {
    NoAuth: 'NoAuth',
    Auth: 'Auth',
    Auth3ds1: 'Auth3ds1',
    Auth3ds2: 'Auth3ds2'
};
/**
 * Enumerated type of Account business verification state that indicates if the company account is verified by business commercial registration
 * @export
 * @enum {string}
 */
export const CommercialRegistrationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CreditCardBrandType = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    Maestro: 'maestro',
    Jcb: 'jcb',
    Amex: 'amex',
    Diners: 'diners',
    Koreanlocal: 'koreanlocal',
    CarteBancaire: 'carte bancaire',
    Mir: 'mir',
    Rupay: 'rupay'
};
/**
 * Customer business type.
 * @export
 * @enum {string}
 */
export const CustomerBusinessType = {
    B2C: 'B2C',
    B2B: 'B2B'
};
export const CustomerTypeIdTypeEnum = {
    _1A: '1A',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3: '3'
};
/**
 * Enumerated type of a failure notification type
 * @export
 * @enum {string}
 */
export const FailureNotificationType = {
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * Describes a filter operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const FilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER',
    IsNotNull: 'IS_NOT_NULL',
    IsNull: 'IS_NULL'
};
/**
 * Enumerated type of the supported filter types:   TEXT_SEARCH - allows to define an arbitrary (free-)text string   VALUE_LIST - allows to select one or more values from a pre-defined list of available values   DATE_RANGE - allows to specify an earliest/latest date (range) criteria   NUMERIC_RANGE - allows to specify a min/max numeric (range) criteria
 * @export
 * @enum {string}
 */
export const FilterOptionType = {
    TextSearch: 'TEXT_SEARCH',
    ValueList: 'VALUE_LIST',
    DateRange: 'DATE_RANGE',
    NumericRange: 'NUMERIC_RANGE'
};
/**
 * Enumerated type of the invitation state.
 * @export
 * @enum {string}
 */
export const InvitationState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Pending: 'PENDING'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LengthType = {
    Kilometer: 'kilometer',
    Meter: 'meter',
    Centimeter: 'centimeter',
    Millimeter: 'millimeter',
    Foot: 'foot',
    Inch: 'inch',
    Yard: 'yard',
    Mile: 'mile'
};
/**
 * Enumerated type of the permission mode
 * @export
 * @enum {string}
 */
export const PermissionMode = {
    Grant: 'GRANT',
    Deny: 'DENY'
};
/**
 * Enumerated type of the state for preferred contacts. The state UNASSIGNED means that a contact is assignable but not yet persisted. The ASSIGNED contacts are already assigned to a company or vehicle.
 * @export
 * @enum {string}
 */
export const PreferredContactState = {
    Unassigned: 'UNASSIGNED',
    Assigned: 'ASSIGNED'
};
/**
 * type of a `RoleConditionGroup` that defines how to build the boolean concatenation of multiple nested `RoleConditionMappings`
 * @export
 * @enum {string}
 */
export const RoleConditionGroupType = {
    And: 'AND',
    Or: 'OR',
    Not: 'NOT'
};
/**
 * Sort order:   * `asc` - Ascending, from A to Z or 0-9   * `desc` - Descending, from Z to A or 0-9
 * @export
 * @enum {string}
 */
export const SortOperator = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Describes a unary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const UnaryBooleanOperator = {
    Not: 'NOT'
};
/**
 * Describes an unary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const UnaryFilterOperator = {
    NotNull: 'IS_NOT_NULL',
    Null: 'IS_NULL'
};
/**
 * Enumerated type of a vehicle authorization
 * @export
 * @enum {string}
 */
export const VehicleAuthorizationType = {
    Company: 'COMPANY',
    User: 'USER',
    UserChooser: 'USER_CHOOSER',
    Partner: 'PARTNER'
};
/**
 * Enumerated type of a notification category
 * @export
 * @enum {string}
 */
export const VehicleNotificationCategory = {
    UrgentAction: 'URGENT_ACTION',
    RetailAction: 'RETAIL_ACTION',
    FleetAction: 'FLEET_ACTION',
    PairingRequest: 'PAIRING_REQUEST',
    UnverifiedVehicle: 'UNVERIFIED_VEHICLE',
    ServiceA: 'SERVICE_A',
    ServiceB: 'SERVICE_B',
    GeneralInspection: 'GENERAL_INSPECTION'
};
/**
 * Enumerated type of a notification status
 * @export
 * @enum {string}
 */
export const VehicleNotificationStatus = {
    Reopened: 'REOPENED',
    New: 'NEW',
    Created: 'CREATED',
    InProgress: 'IN_PROGRESS',
    Sent: 'SENT',
    Delegated: 'DELEGATED'
};
/**
 * Options which define the input state of VehicleSalesDiscountScheme
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeOptionType = {
    None: 'NONE',
    NationalDiscountCode: 'NATIONAL_DISCOUNT_CODE',
    FleetSize: 'FLEET_SIZE',
    FleetSizeCount: 'FLEET_SIZE_COUNT',
    PurchaseCooperative: 'PURCHASE_COOPERATIVE',
    UniqueCustomerId: 'UNIQUE_CUSTOMER_ID'
};
/**
 * Enumerated type of a vehicle type. See mapping logic https://git.daimler.com/dh-io-mmcs/commons-be/blob/master/mmc_connector_client/src/main/java/com/daimler/mymercedes/mmc/backend/connectors/datacontext/VehicleInfoDC.java
 * @export
 * @enum {string}
 */
export const VehicleTypeType = {
    ConnectVehicle: 'CONNECT_VEHICLE',
    HybridVehicle: 'HYBRID_VEHICLE',
    AdapterVehicle: 'ADAPTER_VEHICLE',
    None: 'NONE'
};
/**
 * ActiveUserProfileApi - axios parameter creator
 * @export
 */
export const ActiveUserProfileApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete current Active user profile in the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentActiveUserProfile: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/active-user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Provides the `ActiveUserProfile` of a given user. By default the given user is resolved by the ciamId of the  CIAS JWE header authentication. If JWE token is not provided, an anonymous profile with active customer group  will be returned. The HTTP request is technically still a POST method to rule out any sensitive  data exposure on the URL. The nested optional `IncludeDescriptor` in the request body allows  to pre-initialize an arbitrary set of nested response structures for individual usecases.
         * @param {GetActiveUserProfileBatchRequest} [getActiveUserProfileBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile: (getActiveUserProfileBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/get-active-user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getActiveUserProfileBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Save current Active user profile in the user context.
         * @param {ActiveUserProfileRequest} activeUserProfileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCurrentActiveUserProfile: (activeUserProfileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activeUserProfileRequest' is not null or undefined
            assertParamExists('saveCurrentActiveUserProfile', 'activeUserProfileRequest', activeUserProfileRequest);
            const localVarPath = `/active-user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(activeUserProfileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ActiveUserProfileApi - functional programming interface
 * @export
 */
export const ActiveUserProfileApiFp = function (configuration) {
    const localVarAxiosParamCreator = ActiveUserProfileApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete current Active user profile in the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentActiveUserProfile(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCurrentActiveUserProfile(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Provides the `ActiveUserProfile` of a given user. By default the given user is resolved by the ciamId of the  CIAS JWE header authentication. If JWE token is not provided, an anonymous profile with active customer group  will be returned. The HTTP request is technically still a POST method to rule out any sensitive  data exposure on the URL. The nested optional `IncludeDescriptor` in the request body allows  to pre-initialize an arbitrary set of nested response structures for individual usecases.
         * @param {GetActiveUserProfileBatchRequest} [getActiveUserProfileBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile(getActiveUserProfileBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveUserProfile(getActiveUserProfileBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Save current Active user profile in the user context.
         * @param {ActiveUserProfileRequest} activeUserProfileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCurrentActiveUserProfile(activeUserProfileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveCurrentActiveUserProfile(activeUserProfileRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ActiveUserProfileApi - factory interface
 * @export
 */
export const ActiveUserProfileApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ActiveUserProfileApiFp(configuration);
    return {
        /**
         *
         * @summary Delete current Active user profile in the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentActiveUserProfile(options) {
            return localVarFp.deleteCurrentActiveUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Provides the `ActiveUserProfile` of a given user. By default the given user is resolved by the ciamId of the  CIAS JWE header authentication. If JWE token is not provided, an anonymous profile with active customer group  will be returned. The HTTP request is technically still a POST method to rule out any sensitive  data exposure on the URL. The nested optional `IncludeDescriptor` in the request body allows  to pre-initialize an arbitrary set of nested response structures for individual usecases.
         * @param {GetActiveUserProfileBatchRequest} [getActiveUserProfileBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile(getActiveUserProfileBatchRequest, options) {
            return localVarFp.getActiveUserProfile(getActiveUserProfileBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save current Active user profile in the user context.
         * @param {ActiveUserProfileRequest} activeUserProfileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCurrentActiveUserProfile(activeUserProfileRequest, options) {
            return localVarFp.saveCurrentActiveUserProfile(activeUserProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ActiveUserProfileApi - object-oriented interface
 * @export
 * @class ActiveUserProfileApi
 * @extends {BaseAPI}
 */
export class ActiveUserProfileApi extends BaseAPI {
    /**
     *
     * @summary Delete current Active user profile in the user context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActiveUserProfileApi
     */
    deleteCurrentActiveUserProfile(options) {
        return ActiveUserProfileApiFp(this.configuration).deleteCurrentActiveUserProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Provides the `ActiveUserProfile` of a given user. By default the given user is resolved by the ciamId of the  CIAS JWE header authentication. If JWE token is not provided, an anonymous profile with active customer group  will be returned. The HTTP request is technically still a POST method to rule out any sensitive  data exposure on the URL. The nested optional `IncludeDescriptor` in the request body allows  to pre-initialize an arbitrary set of nested response structures for individual usecases.
     * @param {GetActiveUserProfileBatchRequest} [getActiveUserProfileBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActiveUserProfileApi
     */
    getActiveUserProfile(getActiveUserProfileBatchRequest, options) {
        return ActiveUserProfileApiFp(this.configuration).getActiveUserProfile(getActiveUserProfileBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Save current Active user profile in the user context.
     * @param {ActiveUserProfileRequest} activeUserProfileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActiveUserProfileApi
     */
    saveCurrentActiveUserProfile(activeUserProfileRequest, options) {
        return ActiveUserProfileApiFp(this.configuration).saveCurrentActiveUserProfile(activeUserProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Allows to drop & rebuild all existing owned role & permission data for the given owner
         * @param {RebuildOwnerRequest} rebuildOwnerRequest A configuration file which contains the complete new state of all data owned by the given owner
         * @param {string} [tenant] Name of the tenant to associate as owner for all dropped &amp; (re-)created role &amp; permission entities
         * @param {string} [ownerId] Technical id of the raw owner for all dropped &amp; (re-)created role &amp; permission entities. Fallback if tenant is not applicable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuildByOwner: (rebuildOwnerRequest, tenant, ownerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rebuildOwnerRequest' is not null or undefined
            assertParamExists('rebuildByOwner', 'rebuildOwnerRequest', rebuildOwnerRequest);
            const localVarPath = `/management/permissions/rebuild`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }
            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(rebuildOwnerRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Allows to drop & rebuild all existing owned role & permission data for the given owner
         * @param {RebuildOwnerRequest} rebuildOwnerRequest A configuration file which contains the complete new state of all data owned by the given owner
         * @param {string} [tenant] Name of the tenant to associate as owner for all dropped &amp; (re-)created role &amp; permission entities
         * @param {string} [ownerId] Technical id of the raw owner for all dropped &amp; (re-)created role &amp; permission entities. Fallback if tenant is not applicable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Allows to drop & rebuild all existing owned role & permission data for the given owner
         * @param {RebuildOwnerRequest} rebuildOwnerRequest A configuration file which contains the complete new state of all data owned by the given owner
         * @param {string} [tenant] Name of the tenant to associate as owner for all dropped &amp; (re-)created role &amp; permission entities
         * @param {string} [ownerId] Technical id of the raw owner for all dropped &amp; (re-)created role &amp; permission entities. Fallback if tenant is not applicable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options) {
            return localVarFp.rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary Allows to drop & rebuild all existing owned role & permission data for the given owner
     * @param {RebuildOwnerRequest} rebuildOwnerRequest A configuration file which contains the complete new state of all data owned by the given owner
     * @param {string} [tenant] Name of the tenant to associate as owner for all dropped &amp; (re-)created role &amp; permission entities
     * @param {string} [ownerId] Technical id of the raw owner for all dropped &amp; (re-)created role &amp; permission entities. Fallback if tenant is not applicable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options) {
        return DefaultApiFp(this.configuration).rebuildByOwner(rebuildOwnerRequest, tenant, ownerId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all available conditions & their parameterization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authorization-schema/get-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get permissions of the current user at a given company in the active role context.
         * @param {GetUserPermissionsBatchRequest} getUserPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPermissions: (getUserPermissionsBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getUserPermissionsBatchRequest' is not null or undefined
            assertParamExists('getCurrentUserPermissions', 'getUserPermissionsBatchRequest', getUserPermissionsBatchRequest);
            const localVarPath = `/authorization/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUserPermissionsBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all available roles & their condition setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authorization-schema/get-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all permission customizations of a tenant
         * @param {string} tenant Name of the tenant to resolve the configuration for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfiguration: (tenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getTenantConfiguration', 'tenant', tenant);
            const localVarPath = `/authorization/get-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get permissions in context of given Active User Profiles
         * @param {HasPermissionsBatchRequest} hasPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasPermissions: (hasPermissionsBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'hasPermissionsBatchRequest' is not null or undefined
            assertParamExists('hasPermissions', 'hasPermissionsBatchRequest', hasPermissionsBatchRequest);
            const localVarPath = `/authorization/has-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(hasPermissionsBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all available conditions & their parameterization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConditions(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get permissions of the current user at a given company in the active role context.
         * @param {GetUserPermissionsBatchRequest} getUserPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPermissions(getUserPermissionsBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUserPermissions(getUserPermissionsBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all available roles & their condition setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoles(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all permission customizations of a tenant
         * @param {string} tenant Name of the tenant to resolve the configuration for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfiguration(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTenantConfiguration(tenant, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get permissions in context of given Active User Profiles
         * @param {HasPermissionsBatchRequest} hasPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasPermissions(hasPermissionsBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hasPermissions(hasPermissionsBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all available conditions & their parameterization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditions(options) {
            return localVarFp.getConditions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get permissions of the current user at a given company in the active role context.
         * @param {GetUserPermissionsBatchRequest} getUserPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPermissions(getUserPermissionsBatchRequest, options) {
            return localVarFp.getCurrentUserPermissions(getUserPermissionsBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all available roles & their condition setup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options) {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all permission customizations of a tenant
         * @param {string} tenant Name of the tenant to resolve the configuration for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfiguration(tenant, options) {
            return localVarFp.getTenantConfiguration(tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get permissions in context of given Active User Profiles
         * @param {HasPermissionsBatchRequest} hasPermissionsBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasPermissions(hasPermissionsBatchRequest, options) {
            return localVarFp.hasPermissions(hasPermissionsBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     *
     * @summary Get all available conditions & their parameterization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getConditions(options) {
        return PermissionsApiFp(this.configuration).getConditions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get permissions of the current user at a given company in the active role context.
     * @param {GetUserPermissionsBatchRequest} getUserPermissionsBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getCurrentUserPermissions(getUserPermissionsBatchRequest, options) {
        return PermissionsApiFp(this.configuration).getCurrentUserPermissions(getUserPermissionsBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all available roles & their condition setup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getRoles(options) {
        return PermissionsApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all permission customizations of a tenant
     * @param {string} tenant Name of the tenant to resolve the configuration for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getTenantConfiguration(tenant, options) {
        return PermissionsApiFp(this.configuration).getTenantConfiguration(tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get permissions in context of given Active User Profiles
     * @param {HasPermissionsBatchRequest} hasPermissionsBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    hasPermissions(hasPermissionsBatchRequest, options) {
        return PermissionsApiFp(this.configuration).hasPermissions(hasPermissionsBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserActionPermissionApi - axios parameter creator
 * @export
 */
export const UserActionPermissionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Modifies action permissions of user in a given context
         * @param {ModifyUserActionPermissionsRequest} modifyUserActionPermissionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserActionPermissions: (modifyUserActionPermissionsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'modifyUserActionPermissionsRequest' is not null or undefined
            assertParamExists('modifyUserActionPermissions', 'modifyUserActionPermissionsRequest', modifyUserActionPermissionsRequest);
            const localVarPath = `/authorization/modify-user-action-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(modifyUserActionPermissionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserActionPermissionApi - functional programming interface
 * @export
 */
export const UserActionPermissionApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserActionPermissionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Modifies action permissions of user in a given context
         * @param {ModifyUserActionPermissionsRequest} modifyUserActionPermissionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserActionPermissions(modifyUserActionPermissionsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyUserActionPermissions(modifyUserActionPermissionsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserActionPermissionApi - factory interface
 * @export
 */
export const UserActionPermissionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserActionPermissionApiFp(configuration);
    return {
        /**
         *
         * @summary Modifies action permissions of user in a given context
         * @param {ModifyUserActionPermissionsRequest} modifyUserActionPermissionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserActionPermissions(modifyUserActionPermissionsRequest, options) {
            return localVarFp.modifyUserActionPermissions(modifyUserActionPermissionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserActionPermissionApi - object-oriented interface
 * @export
 * @class UserActionPermissionApi
 * @extends {BaseAPI}
 */
export class UserActionPermissionApi extends BaseAPI {
    /**
     *
     * @summary Modifies action permissions of user in a given context
     * @param {ModifyUserActionPermissionsRequest} modifyUserActionPermissionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserActionPermissionApi
     */
    modifyUserActionPermissions(modifyUserActionPermissionsRequest, options) {
        return UserActionPermissionApiFp(this.configuration).modifyUserActionPermissions(modifyUserActionPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map